<template>
    <div class="inner-wrapper">
        <div class="new-rfq">
            <fieldset class="customer-search mb-3">
                <div class="row">
                    <div class="col-md-12">
                        <div class="btnrow float-right">
                            <a href="javascript:void(0)" @click="addLabel()" class="btn create-btn">
                                Create Label
                            </a>
                        </div>
                    </div>
                </div>
            </fieldset>
            <div class="row">

                <div class="col-lg-12 col-md-12">
                    <div class="card panel">
                        <div class="card-header headnbtn">
                            <h5 class="card-title mb-0">List of Label</h5>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive product-create table-card">
                                <table class="table table-nowrap table-bordered align-middle mb-0 table-custom">
                                    <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Color</th>
                                        <th>Order</th>
                                        <th>Date Added</th>
                                        <th>Date Updated</th>
                                        <th style="width: 80px">Action </th>
                                    </tr>
                                    </thead>
                                    <template v-for="(item, index) in labels">
                                        <tr :key="item.id">
                                            <td :style="'color:' + item.color">{{item.name}}</td>
                                            <td>{{item.color}}</td>
                                            <td>{{item.priority}}</td>
                                            <td>{{formatDate(item.created_at)}}</td>
                                            <td>{{formatDate(item.updated_at)}}</td>
                                            <td>
                                                <a class="edit-btn" href="javascript:void(0);" @click="updateModal(item)" style="font-size: 18px;"><i class="ri-edit-fill me-1"></i></a>
                                            </td>
                                        </tr>
                                    </template>
                                </table>
                            </div>
                            <div class="btnrow card-btn mt-3">
                                <template>
                                    <div class="overflow-auto">
                                        <b-pagination
                                            v-model="current_page"
                                            :total-rows="total"
                                            :per-page="per_page"
                                        ></b-pagination>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="updateLabel" class="modal fade quote-popup">
            <div class="modal-dialog modal-confirm">
                <div class="modal-content" v-if="form">
                    <div class="alert alert-success succ_msg" v-if="successMessage !=null">
                        <strong class="success_msg">{{successMessage}}</strong>
                    </div>
                    <div class="alert alert-danger succ_msg" v-if="errorMessage !=null">
                        <strong class="success_msg">{{errorMessage}}</strong>
                    </div>
                    <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li v-for="(v, k) in commonErrors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </li>
                        </ul>
                    </div>

                    <ValidationObserver v-slot="{ handleSubmit }">
                        <form  @submit.prevent="handleSubmit(updateLabel)" id="editLabelForm" name="addLabelForm" method="post">

                            <div class="modal-header bg-soft-info p-3">
                                <h4 class="modal-title">Edit Label</h4>
                                <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><i class="ri-close-line"></i></button>
                            </div>
                            <div class="modal-body">
                                <div class="form-group">
                                    <validation-provider rules="required" v-slot="{ errors }">
                                        <label for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="form.name">
                                        <span class="error">{{ errors[0] }}</span>
                                    </validation-provider>
                                </div>
                                <div class="form-group">
                                    <label for="priority">Order:</label>
                                    <select class="form-control mdl-textfield__input" id="priority" name="priority" v-model="form.priority">
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Color:</label>
                                    <input type="text" placeholder="#000000" class="form-control" v-model="form.color">

                                </div>
                                <div class="btnrow text-right">
                                    <button type="button" class="btn btn-danger me-1" data-dismiss="modal" aria-hidden="true">Cancel</button>
                                    <button type="submit" class="btn btn-primary">Save</button>
                                </div>
                            </div>
                        </form>
                    </ValidationObserver>
                </div>
            </div>
        </div>



        <div id="createLabel" class="modal fade quote-popup">
            <div class="modal-dialog modal-confirm">
                <div class="modal-content" v-if="form">

                    <div class="alert alert-success succ_msg" v-if="successMessage !=null">
                        <strong class="success_msg">{{successMessage}}</strong>
                    </div>
                    <div class="alert alert-danger succ_msg" v-if="errorMessage !=null">
                        <strong class="success_msg">{{errorMessage}}</strong>
                    </div>
                    <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li v-for="(v, k) in commonErrors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </li>
                        </ul>
                    </div>
                    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                        <form  @submit.prevent="handleSubmit(save)" id="addLabelForm" name="addLabelForm" method="post">

                            <div class="modal-header bg-soft-info p-3">
                                <h4 class="modal-title">Create Label</h4>
                                <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><i class="ri-close-line"></i></button>
                            </div>
                            <div class="modal-body">
                                <div class="form-group">
                                    <validation-provider rules="required" v-slot="{ errors }">
                                        <label>Name:</label>
                                        <input type="text" class="form-control" v-model="form.name">
                                        <span class="error">{{ errors[0] }}</span>
                                    </validation-provider>
                                </div>
                                <div class="form-group">
                                    <label>Order:</label>
                                    <select class="form-control mdl-textfield__input" name="priority" v-model="form.priority">
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label>Color:</label>
                                    <input type="text" placeholder="#000000" class="form-control" v-model="form.color">

                                </div>
                                <div class="btnrow text-right">
                                    <button type="button" class="btn btn-danger me-1" data-dismiss="modal" aria-hidden="true">Cancel</button>
                                    <button type="submit" class="btn btn-primary">Save</button>
                                </div>
                            </div>

                        </form>
                    </ValidationObserver>
                </div>
            </div>
        </div>


        <!-- End Vendor Bag -->
        <!-- Delete Modal HTML -->
        <div id="deleteModal" class="modal fade delete-modal">
            <div class="modal-dialog modal-confirm">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><i class="ri-close-line"></i></button>
                    </div>
                    <div class="modal-body text-center">
                        <div class="trashbtn"><i class="ri-delete-bin-6-line"></i></div>
                        <h4 class="inr-title">Are you sure?</h4>
                        <p>Do you really want to delete these records? This process cannot be undone.</p>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary  me-1" data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-danger confirm_delete" @click="deleteLabel()">Delete</button>
                        </div>
                    </div>

                    <input type="hidden" name="delete_id" id="delete_id" value="">

                </div>
            </div>
        </div>

        <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import { ValidationObserver,ValidationProvider, extend,validate  } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});

// with typescript
for (let [rule, validation] of Object.entries(rules)) {
    extend(rule, {
        ...validation
    });
}
export default {
    name: "Labels",
    components: {
        ValidationProvider,ValidationObserver,
    },
    created() {
        if(localStorage.getItem('token')){
            //console.log("token "+localStorage.getItem('token'));
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
        this.getLabels();
    },
    data(){
        return {
            labels: [],
            current_page:1,
            per_page:10,
            total:0,
            form:{
                id:null,
                name:null,
                color:null,
                priority:1
            },
            showModal: false,
            deleteId: null
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading'
        ]),
        updateLabel(){
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            this.setSuccessMessage(null);
            return axios.put(window.route('labels.update', {id: this.form.id}), this.form, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        $('#updateLabel').modal('hide');
                        self.getLabels();
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });

        },

        save() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            this.setSuccessMessage(null);
            return axios.post(window.route('labels.store'), this.form,{
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                        console.log("Errors ",this.commonErrors);
                        for(var i = 0;i< this.commonErrors.length;i++){
                            console.log("Errors inside ");
                        }
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.customerData = data.data;
                        $('#createLabel').modal('hide');
                        this.getLabels();
                        this.reset();

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        async reset() {
            this.form =  {
                id:null,
                name:null,
                color:null,
                priority:1
            };
            requestAnimationFrame(() => {
                this.$refs.observer.reset();
            });
        },
        getLabels() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('labels.index',{page: this.current_page} ), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    //console.log(data);
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.labels = data.data.data;
                        this.current_page = data.data.current_page;
                        this.per_page = data.data.per_page;
                        this.total = data.data.total;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        addLabel(){
            $('#createLabel').modal('show');
        },
        updateModal(label){
            if(label) {
                this.form =  {
                    id: label.id,
                    name: label.name,
                    color: label.color,
                    priority: label.priority,
                };

                $('#updateLabel').modal('show')
            }
        },
        showDelete(id) {
            this.deleteId = id;
            $('#deleteModal').modal('show');
        },
        hideDelete() { $('#deleteModal').modal('hide'); this.deleteId = null; },
        deleteLabel() {
            if(this.deleteId) {
                let self = this;
                this.setLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                return axios.delete(window.route('labels.destroy', {id: this.deleteId}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({ data }) => {
                        if(data.errors){
                            self.setCommonErrors(data.errors);
                        } else if(data.errorMessage){
                            self.setErrorMessage(data.errorMessage);
                        } else {
                            self.setSuccessMessage(data.data);
                            self.deleteId = null;
                            $('#deleteModal').modal('hide');
                            self.getLabels();

                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                    })
                    .finally(() => {
                        self.setLoading(false);

                    });
            }
        },
        resetField(){
            alert("d");
            this.form = {
                id:null,
                name:null,
                color:null,
                priority:1
            }
        }


    },
    mounted(){
        let self = this;
        $('#updateLabel').on('hidden.bs.modal', function () {
            self.form =  {
                id:null,
                name:null,
                color:null,
                priority:1
            };
        })
    },
    watch: {
        current_page: {
            handler: function(value) {
                this.getLabels();
            }
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
        ])
    }
}
</script>

<style scoped>

</style>
